
export enum DisputeCsvFileUploadStatusCd {
	COMPLETE = 'Complete',
	FAILED = 'Failed',
	IN_PROGRESS = 'InProgress',
	PENDING = 'Pending'}

